import * as Yup from 'yup';

export const addDatasetValidation = () => {
  return Yup.object().shape({
    country: Yup.string().required('required'),
    brandCompany: Yup.string().required('pleaseEnterTheCompanyName'),
    domain: Yup.string().required('required'),
  });
};
